import { CaseStudy } from '@/lib/dto/case-studies/case-studies';
import Image from 'next/image';
import Link from 'next/link';

interface GridCaseStudyCardProps {
    caseStudy: CaseStudy;
}

export default function GridCaseStudyCard({ caseStudy }: GridCaseStudyCardProps) {
    return (
        <Link href={caseStudy.link} className="block">
            <div className="rounded-xl border border-gray-200 overflow-hidden transition-all duration-300 hover:border-gray-300 cursor-pointer h-full">
                {/* Image */}
                <div className="relative h-48 sm:h-56 md:h-64 w-full">
                    <Image
                        src={caseStudy.coverImage}
                        alt={`${caseStudy.title} Cover`}
                        fill
                        className="object-cover"
                        sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 33vw"
                    />
                </div>

                {/* Content */}
                <div className="p-6">
                    {/* Title */}
                    <h3 className="text-lg font-semibold text-gray-900 mb-3 leading-tight line-clamp-2">
                        {caseStudy.title}
                    </h3>

                    {/* Description */}
                    <p className="text-sm text-gray-600 mb-4 line-clamp-3 leading-relaxed">
                        {caseStudy.challenge}
                    </p>

                    {/* Capsule metadata */}
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                            <span className="bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full">
                                {caseStudy.category}
                            </span>
                            <span className="text-xs text-gray-500 font-medium">
                                {caseStudy.duration}
                            </span>
                        </div>
                        <span className="text-xs text-gray-400">
                            {caseStudy.industry}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
} 